import { useQuery } from "react-query";
import api from "../api";
import { API_ROUTES } from "../../utils/const";

const FETCH_KLASHA_WIRE_TRANSACTIONS = async (payload) => {
  const response = await api.post(API_ROUTES.GET_KLASHA_WIRE_PAYMENTS, payload);
  return response.data?.bulkMerchantPayments;
};

export const getKlashaWireFilteredTransactions = (data) => {
  return useQuery({
    queryKey: ["klashaWireFilteredTransactions", data],
    queryFn: () => FETCH_KLASHA_WIRE_TRANSACTIONS(data),
    enabled: !!data.businessId,
  });
};
